import { createAction } from "@reduxjs/toolkit";
import { UI_ACTION_NAME } from "../../types";
import {
  IProduct,
  ISelectItemObjectData,
  optionObjectOptionT,
} from "../uiTypes";

export const undoAction = createAction(UI_ACTION_NAME.UNDO);
export const redoAction = createAction(UI_ACTION_NAME.REDO);
export const addHistoryAction = createAction<{
  before: any;
  after: any;
}>(UI_ACTION_NAME.ADD_HISTORY);

export const initSelectDataObjectAction = createAction<{
  projectId: number;
  product: IProduct;
}>(UI_ACTION_NAME.INIT_SELECT_OBJECT_DATA);

export const updateValueOptionSelectObjectAction = createAction<{
  productId: string;
  type: optionObjectOptionT;
  data: Partial<ISelectItemObjectData>;
}>(UI_ACTION_NAME.UPDATE_VALUE_OPTION_SELECT_OBJECT);

export const finishObjectProcessAction = createAction<{
  productId: string;
  prevProductId: string | null;
  finishGlb?: boolean;
  finishImage?: boolean;
  data: Partial<ISelectItemObjectData>;
}>(UI_ACTION_NAME.FINISH_OBJECT_PROCESS);

export const removeObjectAction = createAction<{
  productId: string;
}>(UI_ACTION_NAME.REMOVE_OBJECT);

export const replaceObjectDataAction = createAction<{
  prevProductId: string;
  product: IProduct;
  projectId: number;
}>(UI_ACTION_NAME.REPLACE_OBJECT_DATA);

export const setSearchValueAction = createAction<string>(
  UI_ACTION_NAME.SET_SEARCH_VALUE
);
